import React from "react";
import { ArrowRight, MapPin, Download, Linkedin } from "lucide-react";
import { profile } from "../mock/mock";

const Hero = () => {
  return (
    <section className="relative pt-28 pb-16 lg:pt-36 lg:pb-20 overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-0 right-0 w-[55%] h-[55%] bg-gradient-to-bl from-bronze/10 via-transparent to-transparent blur-3xl" />
        <div className="absolute bottom-0 left-0 w-[40%] h-[40%] bg-gradient-to-tr from-ink/5 via-transparent to-transparent blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          {/* Left: content */}
          <div className="lg:col-span-7 rise-in order-2 lg:order-1">
            <div className="flex items-center gap-3 mb-6">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-ink/5 border border-ink/10 text-[11px] uppercase tracking-[0.28em] text-ink/70">
                <span className="h-1.5 w-1.5 rounded-full bg-bronze" />
                {profile.eyebrow}
              </span>
            </div>

            <h1 className="font-serif-display text-ink text-[38px] leading-[1.05] sm:text-5xl lg:text-[64px] lg:leading-[1.02] font-light">
              {profile.name}
            </h1>

            <p className="mt-6 font-serif-display text-2xl sm:text-3xl lg:text-[34px] text-ink/85 leading-[1.2] max-w-2xl">
              Business, Technology &amp; Operations Executive
              <span className="italic text-bronze"> — building growth engines for regional enterprises.</span>
            </p>

            <p className="mt-6 text-[15px] lg:text-[16px] text-ink/70 leading-relaxed max-w-2xl">
              {profile.subline}
            </p>

            <div className="mt-9 flex flex-col sm:flex-row flex-wrap gap-3">
              <a
                href="#summary"
                className="group inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-ink text-ivory-50 rounded-sm hover:bg-ink-700 transition-colors text-sm tracking-wide"
              >
                View Executive Profile
                <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </a>
              <a
                href={profile.resumeUrl}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 border border-ink/25 text-ink rounded-sm hover:border-ink hover:bg-ink hover:text-ivory-50 transition-colors text-sm tracking-wide"
              >
                <Download className="h-4 w-4" />
                Download CV
              </a>
              <a
                href={profile.linkedin}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center gap-2 px-5 py-3.5 text-ink rounded-sm hover:text-bronze transition-colors text-sm tracking-wide"
              >
                <Linkedin className="h-4 w-4" />
                Connect on LinkedIn
              </a>
            </div>

            <div className="mt-10 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-ink/55">
              <div className="inline-flex items-center gap-1.5">
                <MapPin className="h-3.5 w-3.5 text-bronze" />
                {profile.location}
              </div>
              <span className="h-px w-6 bg-ink/15" />
              <a href={`mailto:${profile.email}`} className="hover:text-bronze transition-colors">
                {profile.email}
              </a>
              <span className="h-px w-6 bg-ink/15" />
              <a href={`tel:+${profile.phoneRaw}`} className="hover:text-bronze transition-colors">
                {profile.phone}
              </a>
            </div>
          </div>

          {/* Right: portrait */}
          <div className="lg:col-span-5 order-1 lg:order-2 rise-in" style={{ animationDelay: "120ms" }}>
            <div className="relative max-w-md mx-auto">
              <div className="absolute -top-3 -left-3 w-20 h-20 border-t-2 border-l-2 border-bronze" />
              <div className="absolute -bottom-3 -right-3 w-20 h-20 border-b-2 border-r-2 border-bronze" />

              <div className="relative overflow-hidden rounded-sm bg-ink">
                <img
                  src={profile.photo}
                  alt={profile.name}
                  className="w-full h-auto object-cover aspect-[4/5] grayscale-[10%]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/30 via-transparent to-transparent" />
              </div>

              <div className="mt-4 flex items-center justify-between text-[11px] uppercase tracking-[0.22em] text-ink/55">
                <span>Abu Dhabi · {new Date().getFullYear()}</span>
                <span className="text-bronze">— HA</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
